<template>
  <router-view :key="key"></router-view>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {}
  },
  computed:{
    ...mapGetters(['staticUrl']),
    key(){
      return this.$route.name?this.$route.name+ +new Date():this.$route+ +new Date()
    },
  },
  created () {
    document.title = window.documentTitle
  },
}
</script>
